import { render } from "./check-icon.vue?vue&type=template&id=b81a99e0"
import script from "./check-icon.vue?vue&type=script&lang=js"
export * from "./check-icon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__